exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".card-content[data-v-4de089c8]{padding:0}", "", {"version":3,"sources":["/opt/build/repo/src/components/cms/elements/Images.vue"],"names":[],"mappings":"AACA,+BAAgC,SAAU,CACzC","file":"Images.vue","sourcesContent":["\n.card-content[data-v-4de089c8] {padding:0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4de089c8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cms/elements/Images.vue
// module id = 647
// module chunks = 0